import { Instance, SnapshotOut, types } from "mobx-state-tree"

import { withEnvironment } from "../extensions/with-environment";
import { withSetPropAction } from "../extensions/withSetPropAction";
import { IMessage, createMessage } from "../message/Message";

/**
 * # MessageStore
 * 
 * MessageStore을 설명하세요.
 */

export const MessageStore = types
  .model("MessageStore")
  // --------------------------------------------------------------------------
  .props({
    message: createMessage(),
  })
  .extend(withEnvironment)
  .actions(withSetPropAction)
  // eslint-disable-line @typescript-eslint/no-unused-vars
  .views((self) => ({}))
  // --------------------------------------------------------------------------
  // MUTATEs - 모델 상태를 변경
  .actions((self) => ({
    setMessage: (message: IMessage) => {
      self.message = message;
    },
  }))
  // --------------------------------------------------------------------------
  // REQUESTs - 서비스 요청 및 기타 인터페이스 요청 
  .actions((self) => ({
  }))

// --------------------------------------------------------------------------
type TMessageStore = Instance<typeof MessageStore>;
type TMessageStoreSnapshot = SnapshotOut<typeof MessageStore>

export interface IMessageStore extends TMessageStore { }
export type TMessageStoreKeys = keyof TMessageStoreSnapshot & string;
export interface IMessageStoreSnapshot extends TMessageStoreSnapshot { }
export const createMessageStore = () =>
  types.optional(MessageStore, {} as TMessageStore);
